import { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import WheelOfBalance from "./WheelOfBalance";
import Sidebar from "./Sidebar";
import FullScreenToggle from "./FullScreenToggle";
import { Bars3Icon } from "@heroicons/react/24/solid";

export default function App() {
  const [areas, setAreas] = useState(
    [
      "Health",
      "Physical Environment",
      "Career",
      "Finances",
      "Personal Growth",
      "Recreation",
      "Romance",
      "Social",
    ].map((areaName) => {
      return { name: areaName, enabled: true, rating: 0 };
    }),
  );

  useEffect(() => {
    const storedAreas = JSON.parse(localStorage.getItem("wheelOfLifeData"));
    if (storedAreas) {
      setAreas(storedAreas);
    }
  }, []);

  const [enabledAreas, setEnabledAreas] = useState([]);

  useEffect(() => {
    setEnabledAreas(areas.filter((area) => area.enabled));
  }, [areas]);

  const handleAreaChange = (name, newProps) => {
    const newAreas = areas.map((area) => {
      return area.name === name ? { ...area, ...newProps } : area;
    });

    setAreas(newAreas);
    localStorage.setItem("wheelOfLifeData", JSON.stringify(newAreas));
  };

  const addArea = (props) => {
    const newAreas = [...areas, props];
    setAreas(newAreas);
    localStorage.setItem("wheelOfLifeData", JSON.stringify(newAreas));
  };

  const removeArea = (name) => {
    const newAreas = areas.filter((area) => area.name !== name);
    setAreas(newAreas);
    localStorage.setItem("wheelOfLifeData", JSON.stringify(newAreas));
  };

  const app = useRef();

  return (
    <div className="App bg-base-100" ref={app}>
      <Helmet>
        <title>Achiles Wheel</title>
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
      </Helmet>
      <div className="drawer">
        <input id="my-drawer" type="checkbox" className="drawer-toggle" />
        <div className="drawer-content h-screen w-screen">
          <WheelOfBalance
            areas={enabledAreas}
            onAreaChange={handleAreaChange}
            maxRating={10}
            startColor={"#f44336"}
            medianColor={"#ffeb3b"}
            endColor={"#43A047"}
          />
          <label htmlFor="my-drawer" className="absolute left-0 top-0 p-5">
            <Bars3Icon className="text-neutral h-6 w-6" />
          </label>
          <FullScreenToggle element={app} />
        </div>
        <Sidebar
          areas={areas}
          onAreaChange={handleAreaChange}
          addArea={addArea}
          removeArea={removeArea}
        />
      </div>
    </div>
  );
}
